// Feature-definition names (the server feature-definitions catalog). Use with
// `useIsFeatureEnabled` (@app/services/organization-features) to gate UI on the
// org's effective feature state.
//
// Distinct from:
//  - permissions (auth grants, @app/constants/permissions / auth.permissions)
//  - SSM build-time flags (FEATURE_FLAG_* env vars)
export const QUIET_HOURS = 'QUIET_HOURS';
export const CASE_EXPOSURES = 'CASE_EXPOSURES';
export const CASE_SUMMARY = 'CASE_SUMMARY';
export const OUTBOUND_MEDIA = 'OUTBOUND_MEDIA';
export const WRITING_ASSISTANT = 'WRITING_ASSISTANT';
export const TEMPLATE_RECOMMENDATION = 'TEMPLATE_RECOMMENDATION';
export const SUGGEST_MATCHING_CASE_FOR_INBOUND_CALL =
  'SUGGEST_MATCHING_CASE_FOR_INBOUND_CALL';
export const EXTERNAL_VOICE_MESSAGE_INGESTION =
  'EXTERNAL_VOICE_MESSAGE_INGESTION';
// TODO: shared with the save/send work; consolidate into the broader Canada
// flag set later.
export const SEND_BOTH_WELCOME_MESSAGES = 'SEND_BOTH_WELCOME_MESSAGES';
// Gates only the per-case escape hatch, never whether Send Both sends at all.
export const SEND_BOTH_CASE_OVERRIDE = 'SEND_BOTH_CASE_OVERRIDE';
export const OUTREACH_CLAIMS_CASE_CREATION = 'OUTREACH_CLAIMS_CASE_CREATION';
export const REQUIRE_QUEUE_ON_CASE = 'REQUIRE_QUEUE_ON_CASE';
export const ADMIN_ROLE_CHANGES_REQUIRE_SYSTEM_ADMIN =
  'ADMIN_ROLE_CHANGES_REQUIRE_SYSTEM_ADMIN';
export const NEW_NAVIGATION = 'NEW_NAVIGATION';
export const TOTAL_LOSS_ASSIST = 'TOTAL_LOSS_ASSIST';
